import { connect } from "react-redux";
import { getListDuNoChoVay } from "actions/DuNoChoVay";
import { DuNoChoVay } from "components/BaoCao/DuNoChoVay";

const mapStateToProps = (state) => ({
  DuNoChoVay: state.DuNoChoVay,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListDuNoChoVay: (dataSearch) => dispatch(getListDuNoChoVay(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DuNoChoVay);
